import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import ParticleBoard from '../particles/ParticleBoard';

export default class DropContainer extends Phaser.GameObjects.Container {

  constructor(scene) {
    super(scene);

    this.selectedItem = null;
    this.selectorDisplay = null;
    this.selectorPoint = null;
    this.isRotating = null;
    this.lastAngle = null;
    this.startRotation = null; // For history
    this.hasParticles = false;
    this.particleBoard = null;

    this.dropBg = ABCyaPhaser.Images.addImage(0, 0, 'DragAreaBackground', this).setOrigin(0)
      .setInteractive();
    this.dropBg.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.deselectItem, this);

    if (gameData.settings.PARTICLE_TYPE && gameData.settings.PARTICLE_TYPE !== '') {
      this.particleBoard = new ParticleBoard(this.scene, this.dropBg.width, this.dropBg.height);
      this.add(this.particleBoard);
    }

    const spriteNameCheck = this.scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS).has('Base_1');
    if (spriteNameCheck) {
      this.baseItem = ABCyaPhaser.Images.addImage(0, 0, 'Base_1', this).setOrigin(0);
      this.baseItem.x = this.dropBg.width / 2 - this.baseItem.width / 2;
      this.baseItem.y = this.dropBg.height / 2 - this.baseItem.height / 2 + gameData.settings.BASE_ITEM_YOFFSET;

      if (gameData.settings.BASE_FROM_BOTTOM === true) {
        this.baseItem.setOrigin(0.5, 1);
        this.baseItem.x = this.dropBg.width / 2;
        this.baseItem.y = this.dropBg.height - gameData.settings.BASE_ITEM_YOFFSET;
      }
    }

    this.selectorDisplay = ABCyaPhaser.Images.addImage(0, 0, 'RotateItem', this).setInteractive({ pixelPerfect: true });
    this.selectorDisplay.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.startRotating, this);
    this.selectorDisplay.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.stopRotating, this);
    this.selectorDisplay.x = 200;
    this.selectorDisplay.y = 200;
    this.selectorDisplay.angle = 0;
    this.selectorDisplay.alpha = 0;
  };

  changeBaseItem(value) {
    this.baseItem.setFrame(value).setOrigin(0);
    if (gameData.settings.BASE_FROM_BOTTOM === true) {
      this.baseItem.setOrigin(0.5, 1);
    }
  };

  // region **** SELECT & ROTATE ****

  selectItem(item) {
    this.selectedItem = item;
    this.selectorDisplay.x = this.selectedItem.x;
    this.selectorDisplay.y = this.selectedItem.y;
    this.selectorDisplay.rotation = this.selectedItem.rotation;
    this.selectorDisplay.alpha = 1;
    this.bringToTop(this.selectorDisplay);
  };

  deselectItem() {
    this.selectorDisplay.alpha = 0;
    this.selectedItem = null;
  };

  startRotating() {
    this.scene.input.once(Phaser.Input.Events.POINTER_UP, this.stopRotating, this);
    this.scene.input.once(Phaser.Input.Events.GAME_OUT, this.stopRotating, this);

    this.isRotating = true;
    this.startRotation = this.selectedItem.angle;

    this.selectorPoint = this.getWorldTransformMatrix().transformPoint(this.selectorDisplay.x, this.selectorDisplay.y);
    let angle = Math.atan2(this.scene.input.activePointer.y - this.selectorPoint.y, this.scene.input.activePointer.x - this.selectorPoint.x);
    angle = angle * (180 / Math.PI);
    this.lastAngle = Math.abs(angle - this.selectorDisplay.angle);
  };

  stopRotating() {
    this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.stopRotating, this, true);
    this.scene.input.off(Phaser.Input.Events.GAME_OUT, this.stopRotating, this, true);

    this.isRotating = false;
    this.emit('ROTATE_ACTION', { itemRef: this.selectedItem, rotation: this.startRotation });
  };

  /* Called from history undo so any new rotations are setup without jumping */
  setSelectedRotation(value) {
    this.selectorDisplay.angle = value;
  };

  // endregion

  tick(time, delta) {
    if (this.isRotating) {
      let angle = Math.atan2(this.scene.input.activePointer.y - this.selectorPoint.y, this.scene.input.activePointer.x - this.selectorPoint.x);
      angle = angle * (180 / Math.PI) + this.lastAngle;
      this.selectorDisplay.angle = angle;
      this.selectedItem.angle = angle;
    }

    if (this.particleBoard) this.particleBoard.tick(time, delta);
  };
}